let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJs6U")).then(() => parcelRequire('22YUK'));